module.exports = __webpack_public_path__ + "static/img/our-customers-data-center-telefonica.da1a48a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/our-customers/our-customers-data-center-telefonica.jpg
// module id = 705x
// module chunks = 0